//= =======================================================================================
/*                                                                                      *
  alt           [str]
  image         [str || func]
  defaultImg    [str || func]

  Read WIDTH params from styles and apply in SVG images for transforming size
  Default image size 40px
 *                                                                                      */
//= =======================================================================================

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './ImageWithDefault.style';


const ImageWithDefault = (props) => {
  const { alt, image, defaultImg } = props;
  const [useDefaultImg, setUseDefaultImg] = useState(!image);


  if (useDefaultImg && defaultImg) {
    return <s.IMDWrapper className="image-with-default-wrapper">
      {typeof defaultImg === 'function' ? defaultImg(40) : defaultImg}
    </s.IMDWrapper>;
  }
  if (image) {
    if (typeof image === 'function') {
      return <s.IMDWrapper className="image-with-default-wrapper">
        {image(40)}
      </s.IMDWrapper>;
    }
    if (typeof image === 'string') {
      return (
        <s.IMDWrapper className="image-with-default-wrapper">
          <img alt={alt} src={image} onError={() => setUseDefaultImg(true)} />
        </s.IMDWrapper>
      );
    }
  }
  return null;
};

ImageWithDefault.propTypes = {
  alt: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  defaultImg: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

ImageWithDefault.defaultProps = {
  alt: null,
  image: null,
  defaultImg: null,
};

export default ImageWithDefault;
